import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-dollar',
  templateUrl: './dollar.component.html',
  styleUrls: ['./dollar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DollarIconComponent {}
